// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the video and content */
.wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

/* Video container styling */
.oxy-video-container {
    position: relative;
}

/* Video background styling */
video {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    transform: translate(-50%, -50%);
    z-index: -1;
}

/* Overlay on the video */
.oxy-video-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.53);
}


/* Main container for the content */
.maincontainer {
    position: relative;
    z-index: 1;
    padding: 20px;
}

/* Header container with logo */
/*#header {*/
/*    padding: 20px 0;*/
/*}*/

.logo img {
    max-width: 100%;
}

#dashboard-login {
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center;     /* Center vertically */
    height: 100vh;           /* Take full viewport height */
    width: 100%;             /* Take full width */
}

/* Login box styling */
.login-box {
    background-color: rgba(255, 255, 255, 0.8);  /* Slightly transparent background */
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;  /* Max width for the login box */
    margin: 0 auto;  /* Center the login box if necessary */
}

/* Login box container */
.login-box {
    background-color: white;
    padding: 40px;
    border-radius: 8px;
}

/* Form elements styling */
.form-element {
    margin-bottom: 20px;
}

input[type='email'],
input[type='password'] {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Checkbox styling */
.checkbox-holder {
    display: flex;
    align-items: center;
}

.input_checkbox {
    margin-right: 10px;
}

.input_checkbox_label {
    font-size: 14px;
    color: #333;
}

/* Login button */
.button.Login-btn {
    background-color: #373C5F;
    color: white;
    padding: 15px 25px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
}

.button.Login-btn:hover {
    background-color: #373C5F;
}

/* Styling for the main container */
.maincontainer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;  /* Ensure full viewport height */
    width: 100%;    /* Ensure full width */
    flex-direction: column; /* Stack items vertically */
    position: relative;  /* Allow absolute positioning of the heading */
}

/* Styling for the dashboard heading */
.login-box-heading {
    position: absolute;
    top: 125px; /* Adjust distance from the top of the viewport */
    text-align: center;
    color: #fff;
    width: 100%; /* Ensure full width */
    font-size: 36px; /* Adjust size as needed */
    margin-bottom: 20px;
    font-weight: revert;
}

/* Styling for the login box */
.login-box {
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    /*margin-top: 60px; !* Space between heading and login box *!*/
}


/* Responsive styles */
@media (max-width: 768px) {
    .login-box {
        padding: 20px;
    }

    .button.Login-btn {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/login.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,qCAAqC;AACzC;;;AAGA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA,+BAA+B;AAC/B,YAAY;AACZ,uBAAuB;AACvB,IAAI;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,MAAM,sBAAsB;IAC/C,aAAa,YAAY,8BAA8B;IACvD,WAAW,cAAc,oBAAoB;AACjD;;AAEA,sBAAsB;AACtB;IACI,0CAA0C,GAAG,oCAAoC;IACjF,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB,GAAG,gCAAgC;IACnD,cAAc,GAAG,sCAAsC;AAC3D;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,GAAG,gCAAgC;IAC/C,WAAW,KAAK,sBAAsB;IACtC,sBAAsB,EAAE,2BAA2B;IACnD,kBAAkB,GAAG,8CAA8C;AACvE;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,UAAU,EAAE,iDAAiD;IAC7D,kBAAkB;IAClB,WAAW;IACX,WAAW,EAAE,sBAAsB;IACnC,eAAe,EAAE,0BAA0B;IAC3C,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,8DAA8D;AAClE;;;AAGA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* Wrapper for the video and content */\n.wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n/* Video container styling */\n.oxy-video-container {\n    position: relative;\n}\n\n/* Video background styling */\nvideo {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    transform: translate(-50%, -50%);\n    z-index: -1;\n}\n\n/* Overlay on the video */\n.oxy-video-overlay {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.53);\n}\n\n\n/* Main container for the content */\n.maincontainer {\n    position: relative;\n    z-index: 1;\n    padding: 20px;\n}\n\n/* Header container with logo */\n/*#header {*/\n/*    padding: 20px 0;*/\n/*}*/\n\n.logo img {\n    max-width: 100%;\n}\n\n#dashboard-login {\n    display: flex;\n    justify-content: center; /* Center horizontally */\n    align-items: center;     /* Center vertically */\n    height: 100vh;           /* Take full viewport height */\n    width: 100%;             /* Take full width */\n}\n\n/* Login box styling */\n.login-box {\n    background-color: rgba(255, 255, 255, 0.8);  /* Slightly transparent background */\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;  /* Max width for the login box */\n    margin: 0 auto;  /* Center the login box if necessary */\n}\n\n/* Login box container */\n.login-box {\n    background-color: white;\n    padding: 40px;\n    border-radius: 8px;\n}\n\n/* Form elements styling */\n.form-element {\n    margin-bottom: 20px;\n}\n\ninput[type='email'],\ninput[type='password'] {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n/* Checkbox styling */\n.checkbox-holder {\n    display: flex;\n    align-items: center;\n}\n\n.input_checkbox {\n    margin-right: 10px;\n}\n\n.input_checkbox_label {\n    font-size: 14px;\n    color: #333;\n}\n\n/* Login button */\n.button.Login-btn {\n    background-color: #373C5F;\n    color: white;\n    padding: 15px 25px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    width: 100%;\n}\n\n.button.Login-btn:hover {\n    background-color: #373C5F;\n}\n\n/* Styling for the main container */\n.maincontainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 90vh;  /* Ensure full viewport height */\n    width: 100%;    /* Ensure full width */\n    flex-direction: column; /* Stack items vertically */\n    position: relative;  /* Allow absolute positioning of the heading */\n}\n\n/* Styling for the dashboard heading */\n.login-box-heading {\n    position: absolute;\n    top: 125px; /* Adjust distance from the top of the viewport */\n    text-align: center;\n    color: #fff;\n    width: 100%; /* Ensure full width */\n    font-size: 36px; /* Adjust size as needed */\n    margin-bottom: 20px;\n    font-weight: revert;\n}\n\n/* Styling for the login box */\n.login-box {\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;\n    /*margin-top: 60px; !* Space between heading and login box *!*/\n}\n\n\n/* Responsive styles */\n@media (max-width: 768px) {\n    .login-box {\n        padding: 20px;\n    }\n\n    .button.Login-btn {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
